import { ListManager, Paginator } from '@/components'
import useAxiosRequest from '@/hooks/useAxiosRequest'
import usePageTitle from '@/hooks/usePageTitle'
import useQuery from '@/hooks/useQuery'
import people from '@/services/api/people'
import React from 'react'
import { useHistory, useParams } from 'react-router-dom'
import AdoptionsRow from '../AdoptionsRow'

export default function AdoptionsList({ title }) {
  usePageTitle({ title })

  const query = useQuery()
  const { id } = useParams()
  const history = useHistory()
  const { data, loading, error } = useAxiosRequest(people.adoptions, id, query)

  return (
    <div className="modal active" id="modal-id">
      <a type="button" className="modal-overlay" aria-label="Close" onClick={() => history.goBack()} />
      <div className="modal-container">
        <div className="modal-header">
          <a
            type="button"
            className="btn btn-clear float-right"
            onClick={() => history.goBack()}
          />
          <div className="modal-title h5">Adoções do usuário</div>
          <small>
            {data?.countCastrations === 1 ? '1 adoção' : `${data?.countAdoptions} adoções`}
          </small>
        </div>
        <div className="modal-body">
          <div className="content">
            <ListManager loading={loading} count={data?.count || 0} error={error}>
              <cite>Lista de todas as adoções do usuário</cite>
              <div className="divider" />
              <AdoptionsRow adoptions={data?.rows} />
              {
                Boolean(data) && (
                  <div className="float-right my-2">
                    <Paginator paginatedList={data} />
                  </div>
                )
              }
            </ListManager>
          </div>
        </div>
      </div>
    </div>
  )
}
